import { t as createFetchClient } from "./createFetchClient-Dc_ZMuq7.js";
// src/fetchClient/createOpenapiFetchClient.ts
const createOpenapiFetchClient = (defaultOptions) => createFetchClient(defaultOptions);
export { createOpenapiFetchClient as t };

//# sourceMappingURL=createOpenapiFetchClient-DSk29o_s.js.map